import * as React from "react";
import { useCLEcommContext } from "../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
import { isSinglePurchase } from "../../../../../../../../../../types/types/typeguards.js";
import { CartDiscountSelectorContainer } from "../../../../../../../../components/CartDiscountSelector/modules/EcommContent/components/CartDiscountSelector/CartDiscountSelectorContainer.js";
const CLCartDiscountSelector = ({ className }) => {
  const { state, selectors, actions } = useCLEcommContext();
  const enabledSelectedQuantity = selectors.getEnabledSelectedQuantity(state);
  const isSinglePurchaseType = isSinglePurchase(state.configurations.purchaseType);
  if (!isSinglePurchaseType) {
    return null;
  }
  const handleCartDiscountSelection = (discount, isSelected) => {
    if (isSelected) {
      return;
    }
    actions.updateTotalQuantity(discount.minimumQuantity);
  };
  const handleCartDiscountReset = () => {
    actions.resetTotalQuantity();
  };
  return /* @__PURE__ */ React.createElement(
    CartDiscountSelectorContainer,
    {
      className,
      selectedQuantity: enabledSelectedQuantity || void 0,
      onCartDiscountSelection: handleCartDiscountSelection,
      onCartDiscountReset: handleCartDiscountReset
    }
  );
};
export {
  CLCartDiscountSelector
};
//# sourceMappingURL=CLCartDiscountSelector.js.map
